module.exports = __webpack_public_path__ + "static/logoSantander-c844caa28b83c649ae9c04d14daacfdc.svg";